import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import React from "react";
import "./ExtendRatesDialog.css";

const Transition = React.forwardRef(function Transition(props, ref) {
   return <Slide direction="up" ref={ref} {...props} />;
});

const ExtendRatesDialog = (props) => {
   var extendRatesTitle = props.title || "Extend Rates?";
   var extendRatesText =
      props.text || "Are you sure you want to extend all rates for all lanes? Do you wish to continue?";

   return (
      <Dialog
         className="extend-rates-modal"
         open={props.open || false}
         TransitionComponent={Transition}
         keepMounted
         onClose={props.handleClose}
      >
         <DialogTitle className="dialog-title">{extendRatesTitle}</DialogTitle>
         <DialogContent className="dialog-content">
            <DialogContentText>{extendRatesText}</DialogContentText>
         </DialogContent>
         <DialogActions className="actions">
            <Tooltip title="Cancel" arrow>
               <IconButton onClick={props.handleCancel} variant="contained" color="default">
                  <CloseIcon />
               </IconButton>
            </Tooltip>
            <Tooltip title="Extend Rates" arrow>
               <IconButton onClick={props.extendRatesFunc} variant="contained" color="primary">
                  <SaveIcon />
               </IconButton>
            </Tooltip>
         </DialogActions>
      </Dialog>
   );
};

ExtendRatesDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   text: PropTypes.string.isRequired,
   title: PropTypes.string.isRequired,
   extendRatesFunc: PropTypes.func.isRequired,
   handleClose: PropTypes.func.isRequired,
   handleCancel: PropTypes.func.isRequired,
};

ExtendRatesDialog.defaultProps = {
   open: false,
   text: "",
   title: "",
   extendRatesFunc: () => {
      return;
   },
   handleClose: () => {
      return;
   },
   handleCancel: () => {
      return;
   },
};

export default ExtendRatesDialog;
